import { JupiterTheme } from '@jupiterone/jupiter-web-toolkit';
import LibraryIcon from '@jupiterone/react-brand-icons/jupiterone/library';
import IconButton, { IconButtonProps } from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import { createStyles, makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import React from 'react';

const useStyles = makeStyles((theme: JupiterTheme) =>
  createStyles({
    icon: {
      height: 29,
      width: 29,
      strokeWidth: 2,
    },
    iconButton: {
      alignSelf: 'flex-start',
      padding: theme.spacing(1.75),
      borderRadius: theme.spacing(0.5, 0, 0, 0.5),
      height: 60,
      position: 'relative',
      '&:after': {
        background: theme.palette.grey[300],
        content: `''`,
        display: 'block',
        width: 1,
        height: 60,
        position: 'absolute',
        right: -1,
        top: -1,
      },
      '&:hover svg': {
        color: theme.palette.primary.dark,
      },
    },
    active: {
      background: theme.palette.background.dark,
      '&:hover': {
        background: theme.palette.background.dark,
        '& svg': {
          color: theme.palette.coolGrey[200],
        },
      },
      '& svg': {
        color: theme.palette.primary.main,
      },
    },
    buttonLabel: {
      color: theme.palette.coolGrey[300],
    },
  })
);

interface Props extends IconButtonProps {
  active: boolean;
}

const LibraryButton = ({ active, ...props }: Props) => {
  const classes = useStyles();

  return (
    <Tooltip title="Query Library" enterDelay={500} placement="top">
      <IconButton
        className={clsx(classes.iconButton, active && classes.active)}
        classes={{
          label: classes.buttonLabel,
        }}
        aria-label="Library"
        {...props}
      >
        <LibraryIcon className={classes.icon} />
      </IconButton>
    </Tooltip>
  );
};

export default LibraryButton;
